import Tabs from '../components/tabs.js';
import CardLinks from '../components/card-links.js';
import CustomAccordions from '../components/custom-accordions.js';
import ApiParams from '../components/api-params.js';
import ApiDropdown from '../components/api-dropdown.js';
import PageAccordions from '../components/page-accordions.js';
import CodeBlocks from '../components/code-block.js';
import DynamicTable from '../components/dynamic-table.js';

export default class LayoutUpdater {
  constructor() {
    this.classes = {
      tabs: Tabs,
      customAccordions: CustomAccordions,
      apiParams: ApiParams,
      apiDropdown: ApiDropdown,
      codeBlocks: CodeBlocks,
      dynamicTable: DynamicTable,
    };
  }

  update() {
    this._injectDynamicContent();
    this._initializeDynamicContent();
    this._rerunPageListeners();
  }

  _injectDynamicContent() {
    $('.subscription-container').append(
      `<script id='hsforms-js' src='https://js.hsforms.net/forms/embed/v2.js'></script>`,
    );
  }

  _rerunPageListeners() {
    this._reInitializeInstance('tabs');
    this._reInitializeInstance('codeBlocks');
    this._reInitializeInstance('customAccordions');
    this._reInitializeInstance('apiDropdown');
    if (document.body.querySelector('.payment-table-container')) {
      this._reInitializeInstance('dynamicTable');
    }
    this._reInitializeInstance('apiParams', this.customAccordions);
  }

  _initializeDynamicContent() {
    new PageAccordions('.accordion');
    new CardLinks();
    $('.site-sidebar').removeClass('in');
  }

  _reInitializeInstance(instanceName, ...args) {
    if (this[instanceName]) {
      this[instanceName].stopListening();
      delete this[instanceName];
    }
    this[instanceName] = new this.classes[instanceName](...args);
    this[instanceName].listenEvents();
  }
}
